// Team locations are stored as "City-State" (e.g. "Gainesville-Florida").
// Show them as "Gainesville, Florida". Only the last dash is the separator, so
// hyphenated cities stay intact ("Winston-Salem-North Carolina").
export const formatLocation = (location) => {
  if (!location || typeof location !== 'string') return location;
  const value = location.trim();
  if (value.includes(',')) return value;
  const match = value.match(/^(.*\S)\s*-\s*(\S.*)$/);
  return match ? `${match[1]}, ${match[2]}` : value;
};
